import { alpha } from '@mui/material/styles';
import { keyframes } from 'tss-react';
import { makeStyles } from 'tss-react/mui';

import { HIGHLIGHT_CELL_CLASSES, HIGHLIGHT_DURATION_MS } from './use-scroll-to-report-cell';

/**
 * The same fade under two keyframes names, one per highlight class. The `from` / `0%` spelling
 * is what keeps them apart: keyframes with identical text share one generated name.
 */
const cellHighlightFade = keyframes`
  from { background-color: var(--highlight-tint); box-shadow: inset 0 0 0 2px var(--highlight-ring) }
  to { background-color: transparent; box-shadow: inset 0 0 0 2px transparent }
`;
const cellHighlightFadeRepeat = keyframes`
  0% { background-color: var(--highlight-tint); box-shadow: inset 0 0 0 2px var(--highlight-ring) }
  100% { background-color: transparent; box-shadow: inset 0 0 0 2px transparent }
`;

/**
 * Styles the deep-linked cell flash: a light tint, so the cell's text stays readable, inside the
 * ring color the other arrival highlights use. The ring is an inset shadow, so it takes no space.
 *
 * `grid` goes on the report grid root, and the rules match the classes `getCellHighlightClassName`
 * hands the grid. They are nested under the grid on purpose: tss-react has no `@global`, and a
 * rule written that way is silently dropped.
 */
export const useCellHighlightStyles = makeStyles()(theme => {
  const colors = {
    '--highlight-ring': theme.palette.primary.main,
    '--highlight-tint': alpha(theme.palette.primary.main, 0.16),
  };
  return {
    grid: {
      [`& .${HIGHLIGHT_CELL_CLASSES[0]}`]: {
        ...colors,
        animation: `${cellHighlightFade} ${HIGHLIGHT_DURATION_MS}ms ease-out forwards`,
      },
      [`& .${HIGHLIGHT_CELL_CLASSES[1]}`]: {
        ...colors,
        animation: `${cellHighlightFadeRepeat} ${HIGHLIGHT_DURATION_MS}ms ease-out forwards`,
      },
    },
  };
});
